export default __webpack_public_path__ + "static/media/edit-campaign-prevent.f356f63f.png";